<template>
    <i-table size="small" border :columns="columns" :data="dataSource"></i-table>
</template>

<script>
export default {
    props: {
        data: Array
    },
    data() {
        return {
            columns: [
                {
                    title:'产权编号',
                    key:'estateNumber'
                },
                {
                    title: '产权人姓名',
                    key:'estateName'
                },
                {
                    title:'产权人身份证号',
                    key:'estateIdcard'
                },
                {
                    title:'产权状态',
                    key:'estateStatus'
                },
                {
                    title:'房屋用途',
                    key:'estateUse'
                },
                {
                    title:'共有情况',
                    key:'commonSituation'
                },
                {
                    title:'产权地址',
                    key:'estateAddress'
                },
                {
                    title:'小区名称',
                    key:'residentialName'
                },
                {
                    title:'第二产权人',
                    key:'secondEstateName'
                },
                {
                    title:'第二产权人身份证号',
                    key:'secondEstateIdcard'
                },
                {
                    title:'第二产权人比例',
                    key:'secondPropertyRights'
                },
                {
                    title:'产权比例',
                    key:'propertyRights'
                },
                {
                    title:'受理时间',
                    key:'processingTime'
                }
            ],
            dataSource: []
        }
    },
    watch: {
        data: function(newVal){
            this.dataSource = newVal
        }
    },
   
}
</script>

<style lang="less" scoped>

</style>